import api from './client';

export const categoriesApi = {
  // ─── Category CRUD ─────────────────────────────────────────────────────
  getAll: () => api.get('/categories').then((r) => r.data),

  getById: (id) => api.get(`/categories/${id}`).then((r) => r.data),

  getItems: (id, params = {}) =>
    api.get(`/categories/${id}/items`, { params }).then((r) => r.data),

  create: (dto) => api.post('/categories', dto).then((r) => r.data),

  update: (id, dto) => api.patch(`/categories/${id}`, dto).then((r) => r.data),

  delete: (id, opts = {}) =>
    api.delete(`/categories/${id}`, { data: opts }).then((r) => r.data),

  reorder: (orderedCategoryIds) =>
    api.post('/categories/reorder', { orderedCategoryIds }).then((r) => r.data),

  // ─── Sharing ───────────────────────────────────────────────────────────
  share: (id, dto) => api.post(`/categories/${id}/shares`, dto).then((r) => r.data),

  getShares: (id) => api.get(`/categories/${id}/shares`).then((r) => r.data),

  updateShare: (id, shareId, dto) =>
    api.patch(`/categories/${id}/shares/${shareId}`, dto).then((r) => r.data),

  revokeShare: (id, shareId) =>
    api.delete(`/categories/${id}/shares/${shareId}`).then((r) => r.data),

  getSharedWithMe: () => api.get('/categories/shared-with-me').then((r) => r.data),

  getSharedByMe: () => api.get('/categories/shared-by-me').then((r) => r.data),
};
